export const UNAUTH_USER = 'UNAUTH_USER';
export const AUTHENTICATED = 'AUTHENTICATED';
export const GET_ISSUES_LIST = 'GET_ISSUES_LIST';
export const GET_ISSUES_STATS = 'GET_ISSUES_STATS';

// issue details
export const GET_ISSUE_DETAILS = 'GET_ISSUE_DETAILS';
export const RESET_ISSUE_DETAILS = 'RESET_ISSUE_DETAILS';

// fingerpint
export const GET_TECHNOLOGIES_DATA = 'GET_TECHNOLOGIES_DATA';
export const RESET_TECHNOLOGIES_STATE = 'RESET_TECHNOLOGIES_STATE';
export const SEARCH_TECHNOLOGY_BROWSER = 'SEARCH_TECHNOLOGY_BROWSER';
